import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import propTypes from 'prop-types';

import EmptyCart from '../../components/EmptyCart/EmptyCart.jsx';
import { ProductsTable } from '../../components/ProductsTable/ProductsTable.jsx';
import Pills from '../../components/Pills/Pills.jsx';
import { ConfirmRemove } from '../../components/ConfirmRemove/ConfirmRemove.jsx';
import { StickyActionsBlock } from '../../components/ActionsBlock/StickyActionsBlock.jsx';

class MyCartComponent extends Component {
  componentDidMount() {
    const { optionsStore, labelsStore, cartStore, totalQuantity, uiStore } = this.props;

    if (optionsStore.isCartTransferAvailable && totalQuantity) {
      cartStore.getRetailers();
    }

    if (optionsStore.isBufferMerged) {
      uiStore.notificator.show(labelsStore.isBufferMergedText);
    }
  }

  componentDidUpdate(prevProps) {
    const { optionsStore, cartStore, productsNumber } = this.props;

    if (optionsStore.isCartTransferAvailable
      && (prevProps.productsNumber !== productsNumber)
      && productsNumber) {
      cartStore.getRetailers();
    }
  }

  render() {
    const { optionsStore, labelsStore, uiStore, confirmStore, cartStore } = this.props;
    const { isMobile } = uiStore;
    const { hidePills } = optionsStore;

    const mainColumn = cartStore.hasCards
      ? <ProductsTable />
      : <EmptyCart />;
    const confirmDialog = confirmStore.isShown && <ConfirmRemove/>;
    const shouldShowAdditional = cartStore.hasCards
      && isMobile
      && (optionsStore.isDeliveryDisplay || optionsStore.isPriceEnabledOnSite);

    const additionalInfo = shouldShowAdditional && (
      <div className="my-cart__additional">
        {optionsStore.isDeliveryDisplay && <p className="my-cart__text">{labelsStore.expectedDeliveryDaysLabel}</p>}
        {optionsStore.isPriceEnabledOnSite && !optionsStore.isWeeePricesVisible && <p className="my-cart__text">{labelsStore.priceTaxLabel}</p>}
      </div>
    );

    return (
      <>
        <h1 className="my-cart-header">
          {labelsStore.basketTitle}
        </h1>

        <div className="my-cart">

          {confirmDialog}

          <div className="my-cart__wrapper">

            {!isMobile && !hidePills && <Pills />}

            <div className="my-cart__main">

              {isMobile && !hidePills && <Pills />}

              <div className="my-cart__table">
                {mainColumn}
              </div>

              {!cartStore.isEmptyCart && <StickyActionsBlock />}

              {additionalInfo}

            </div>
          </div>
        </div>
      </>
    );
  }
}

MyCartComponent.propTypes = {
  cartStore: propTypes.shape({
    hasCards: propTypes.bool,
    isEmptyCart: propTypes.bool,
    getRetailers: propTypes.func
  }).isRequired,
  totalQuantity: propTypes.number.isRequired,
  productsNumber: propTypes.number.isRequired,
  uiStore: propTypes.shape({
    isMobile: propTypes.bool,
    notificator: propTypes.object
  }).isRequired,
  optionsStore: propTypes.shape({
    isBufferMerged: propTypes.bool,
    isDeliveryDisplay: propTypes.bool,
    isPriceEnabledOnSite: propTypes.bool,
    isWeeePricesVisible: propTypes.bool,
    isCartTransferAvailable: propTypes.bool,
    hidePills: propTypes.bool
  }).isRequired,
  labelsStore: propTypes.shape({
    isBufferMergedText: propTypes.string,
    expectedDeliveryDaysLabel: propTypes.string,
    priceTaxLabel: propTypes.string
  }).isRequired,
  confirmStore: propTypes.shape({
    isShown: propTypes.bool
  }).isRequired
};

export const MyCart = inject((allStores) => ({
  confirmStore: allStores.confirmStore,
  cartStore: allStores.cartStore,
  uiStore: allStores.uiStore,
  optionsStore: allStores.optionsStore,
  labelsStore: allStores.labelsStore,
  totalQuantity: allStores.cartStore.totalQuantity,
  productsNumber: allStores.cartStore.productsNumber
}))(observer(MyCartComponent));
